import {Dialog, DialogContentText, DialogTitle} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {ActionButton, CancelButton} from '../common/ActionButtons';
import {StyledDialogActions, StyledDialogContent,} from '../data-sources/CreateDataSourceDialog.styled';

interface ConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: React.ReactNode;
    confirmButtonText?: string;
    cancelButtonText?: string;
}

const ConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmButtonText,
    cancelButtonText
}: ConfirmationDialogProps) => {
    const {t} = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{title}</DialogTitle>

            <StyledDialogContent>
                <DialogContentText id="confirmation-dialog-description" sx={{p: "24px 16px"}}>
                    {message}
                </DialogContentText>
            </StyledDialogContent>

            <StyledDialogActions>
                <CancelButton onClick={onClose}>
                    {cancelButtonText || t('confirmationDialog.cancel')}
                </CancelButton>

                <ActionButton onClick={onConfirm} variant="contained" color="error">
                    {confirmButtonText || t('confirmationDialog.confirm')}
                </ActionButton>
            </StyledDialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
